var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreShirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 80,
    width: 120,
    height: 120,
    rx: 20,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 80,
    width: 30,
    height: 40,
    rx: 10,
    fill: "#ff4444"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 80,
    width: 30,
    height: 40,
    rx: 10,
    fill: "#ff4444"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 60,
    width: 60,
    height: 30,
    rx: 10,
    fill: "#ff4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreShirt);
export default __webpack_public_path__ + "static/media/store-shirt.d8bb853a4954769c14709b2052e693ce.svg";
export { ForwardRef as ReactComponent };